import React, { useEffect, useRef } from "react";
import AppStoreBadge from "../Assets/App_Store.svg";
import PlayStoreBadge from "../Assets/Google_Play.svg";
import AOS from "aos";
import "aos/dist/aos.css";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

const Download = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);
  const prefersReducedMotion = useReducedMotion();

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"],
  });
  const orbOneY = useTransform(scrollYProgress, [0, 1], ["-24%", "24%"]);
  const orbTwoY = useTransform(scrollYProgress, [0, 1], ["20%", "-20%"]);

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <section className="download-container" id="download" ref={sectionRef}>
      <div className="download-card-light" data-aos="fade-up" data-aos-delay="100">
        <div className="download-bg" aria-hidden="true">
          <motion.div
            className="download-blob download-blob-1"
            style={prefersReducedMotion ? undefined : { y: orbOneY }}
          />
          <motion.div
            className="download-blob download-blob-2"
            style={prefersReducedMotion ? undefined : { y: orbTwoY }}
          />
          <div className="download-blob download-blob-3" />
        </div>
        <div className="download-hero">
          <h2 className="download-heading">{t("download_title")}</h2>
          <p className="download-text">{t("download_desc")}</p>

          <div className="download-button">
            <a
              className="store-badge"
              href="https://apps.apple.com/us/app/aroundu/id6470918157"
            >
              <img src={AppStoreBadge} alt="Download on the App Store" />
            </a>
            <a
              className="store-badge"
              href="https://play.google.com/store/apps/details?id=app.aroundu"
            >
              <img src={PlayStoreBadge} alt="Get it on Google Play" />
            </a>
            <a
              className="download-community-btn"
              href="https://community.aroundu.app"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("explore_community")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Download;
